import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichmentLoadingComponent = () => /*#__PURE__*/_jsx(_Fragment, {});